module.exports = __webpack_public_path__ + "media/images/recruit/section/bumon_sp-ebcaf170d94fe95b53364eb5a26235f5.svg";